import React from 'react';
import { Link } from 'react-router-dom';
import cl from './Footer.module.css';

export default function Footer() {
    return (
        <footer className={cl.footer}>
            <div className={cl.inner}>
                <div className={cl.col}>
                    <div className={cl.logo}>
                        <span className={cl.logoMark}>SK</span>
                        <span>СтартКласс</span>
                    </div>
                    <p className={cl.tagline}>
                        СтартКласс — готовая образовательная платформа для
                        детских центров. Майнкрафтия + Роботехника по подписке.
                    </p>
                </div>

                <div className={cl.col}>
                    <h4>Платформы</h4>
                    <a href="https://minecraftia-school.ru" target="_blank" rel="noopener noreferrer">
                        Майнкрафтия
                    </a>
                    <a href="https://robotehnick.ru" target="_blank" rel="noopener noreferrer">
                        Роботехника
                    </a>
                    <a href="https://adminpanelminecraftia.ru" target="_blank" rel="noopener noreferrer">
                        Админ-панель
                    </a>
                </div>

                <div className={cl.col}>
                    <h4>Информация</h4>
                    <Link to="/articles">Статьи и FAQ</Link>
                    <a href="/#tariff">Тариф</a>
                    <Link to="/oferta">Договор-оферта</Link>
                    <Link to="/privacy">Конфиденциальность</Link>
                </div>

                <div className={cl.col}>
                    <h4>Контакты</h4>
                    <a href="mailto:maksimivankov26@yandex.ru">
                        maksimivankov26@yandex.ru
                    </a>
                    <span className={cl.muted}>
                        ИП Иванкова В.С.<br/>
                        ИНН 233507286445<br/>
                        ОГРНИП 322237500039230
                    </span>
                </div>
            </div>

            <div className={cl.bottom}>
                © 2026 СтартКласс · Все права защищены
            </div>
        </footer>
    );
}
